import { AxiosGet } from 'shared/libs/axios';

// 장비분류 목록 조회 (tspt_eqpmn_cl 테이블)
export const fetchEquipmentClList = () =>
  AxiosGet('/cl-list', undefined, {
    baseURL: `${process.env.REACT_APP_DOMAIN || ''}/tsp-api/api`
  });

export {};

